import React, { useRef } from "react";
import { Card, Icon, Loader, Button } from "semantic-ui-react";

const ElementFocus = ({ element, list, icon, entity, children, importFunction, actionsButton, actionsFunction, ...props }) => {
	const refContainer = useRef(null);

	if (element.loading) {
		return (
			<div style={{ ...styles.sidebarContainer, position: "relative" }}>
				<Loader active />
			</div>
		);
	}
	if (element.data === null) {
		return (
			<div style={_sidebarContainer(entity)}>
				<Card style={{ margin: "auto" }}>
					<Icon name={icon} size="huge" style={{ margin: "20px auto" }} />
					<Card.Content>
						<Card.Header style={{ textAlign: "center" }}>{entity}</Card.Header>
					</Card.Content>
					<Card.Content extra>
						{list.loading && <Loader active inline size="tiny" />}
						{!list.loading && list.data && (
							<div>
								<Icon name="numbered list" />
								{list.data.length} {entity}
							</div>
						)}
					</Card.Content>
					{importFunction && (
						<Card.Content>
							<input
								type="file"
								id="file"
								ref={refContainer}
								style={{ opacity: "0", height: 0, width: 0 }}
								onChange={(e) => {
									if (e.target.files.length > 0) importFunction(e.target.files[0]);
									e.target.value = "";
								}}
							/>
							<label htmlFor="my_folder_input">
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										refContainer.current.click();
									}}
								>
									Importer
								</Button>
							</label>
						</Card.Content>
					)}
					{actionsButton &&
						actionsFunction &&
						actionsFunction.length > 0 &&
						actionsButton.length > 0 &&
						actionsButton.map((action, i) => (
							<Button
								key={`button-${i}`}
								type="button"
								onClick={actionsFunction[i]}
								style={{ float: "right", backgroundColor: "#00a794", color: "white", margin: "1px 0" }}
							>
								{action}
							</Button>
						))}
				</Card>
			</div>
		);
	} else {
		return (
			<div style={_sidebarContainer(entity)}>
				<div style={styles.sidebarContent} className="focusElementContent">
					{children}
				</div>
			</div>
		);
	}
};

const _sidebarContainer = (entity) => ({
	width: entity === "Géneral" ? "100%" : "80%",
	height: "100%",
	overflowY: "hidden",
	display: "inline-block",
	fontSize: "1rem",
	padding: "10px 3px 10px 10px",
});

const styles = {
	sidebarContainer: {
		width: "80%",
		minHeight: "100vh",
		overflowY: "hidden",
		display: "inline-block",
		fontSize: "1rem",
		padding: "10px 3px 10px 10px",
	},
	sidebarContent: {
		height: "100vh",
		paddingBottom: 50,
		overflowY: "auto",
	},
};

export default ElementFocus;
